import React, { useEffect, useCallback, useState} from 'react';
import CirklonModeButton from './CirklonModeButton.js';
import {connect} from 'react-redux';
import Dropdown from 'react-dropdown';
import {
    setCirklonParameterSelected
} from 'actions/index.js';

/*
const PARAMS = [
    "Duration",
    "Transpose",
    "Velocity",
    "Chop",
    "Panning",
];

*/

const CirklonParameterChooser = ({
    color,
    parameter,
    setParameter,
    track,
    stepDatas
}) => { 
    const PARAMS = track.getStepDataParams();
    const [parameters, setParameters] = useState([... PARAMS]);

    const options = PARAMS.map(
        x => ({label: x, value: x}));

    const onChange = useCallback((opt) => {
        setParameter(opt.value);
    }, [setParameter, setParameters, parameters]);

    let style = {
        backgroundColor: color
    };

    useEffect(() => {
        if (!parameter) {
            setParameter("Velocity");
        }
    }, [parameter]);

    return (
        <div className="cirklon-parameter-chooser">
          {parameters.map(
              (x,i) =>
                  <div
                    key={i}
                    style={
                        parameter === x ? style : {}
                    }
                    onClick={() => onChange({value: x})}
                    className={(parameter === x ? "param-btn selected" : "param-btn") + " " + x.split(" ").join("")}>{x}</div>)}
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      parameter: state.cirklon.cirklonParameterSelected[props.track.id]
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
      setParameter: param => dispatch(setCirklonParameterSelected(props.track.id, param)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CirklonParameterChooser);
